

















































import { logout } from '@/utils/ApiServices'
import { Component, Vue } from 'vue-property-decorator'
import DialogConfirm from '@/components/DialogConfirm.vue'

@Component({
  components: {
    DialogConfirm,
  }
})
export default class NavDrawerAccount extends Vue {
  show = false

  get isSuperUser () {
    return this.$store.getters.isSuperUser
  }

  confirmLogout = false

  logout () {
    logout()
      .then(() => {
        this.$store.dispatch('clearUserInfo')
        this.$store.dispatch('clearCompanies')
        this.$router.push({ name: 'Authen' })
      })
      .finally(() => {
        this.confirmLogout = false
      })
  }
}
